<template>
  <MTableCell>
    <div class="m-table-cell-period-performance text text--xs">
      <span>{{ itemText }}</span>
    </div>
  </MTableCell>
</template>

<script>
  import {mTableCells} from '@marilyn/marilyn-ui';
  import {HYPHEN_MINUS, EM_DASH, NON_BREAKING_SPACE} from 'appConstants';

  export default {
    name: 'MTableCellPeriodPerformance',
    components: {
      MTableCell: mTableCells.MTableCell
    },
    props: {
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      }
    },
    computed: {
      itemText () {
        const longDashWithSpaces = `${NON_BREAKING_SPACE}${EM_DASH}${NON_BREAKING_SPACE}`;
        return this.tableRow?.[this.itemKey]?.replace(HYPHEN_MINUS, longDashWithSpaces) || null;
      }
    }
  };
</script>

<style>
  .m-table-cell-period-performance {
    color: var(--color-text-tertiary);

  }
</style>
